import { GTMEvent } from '../GTM'
import { formatPrice } from '@corratech/pylot-seo'
import { itemHasKeys } from '@corratech/pylot-utils'

type GTMOrderActionField = {
    order_id: string
    affiliation?: string
    revenue: number
    tax?: number
    shipping?: number
    coupon: string
    discount: number
}

const isValidOrderAction = (data: unknown): data is GTMOrderActionField => {
    return itemHasKeys(data, ['id', 'revenue'])
}

export const pushOrder = (data: Record<string, unknown>): GTMEvent => {
    const { actionField, productsDetails = [] } = data

    if (!isValidOrderAction(actionField)) {
        console.info('Invalid GTM order data')
        return { event: '' }
    }

    const {
        order_id,
        affiliation,
        revenue,
        tax,
        shipping,
        coupon,
        discount
    } = actionField

    return {
        event: 'purchase',
        ecommerce: {
            purchase: {
                actionField: {
                    id: order_id,
                    affiliation,
                    revenue: formatPrice(revenue),
                    tax: formatPrice(tax),
                    shipping: formatPrice(shipping),
                    coupon,
                    discount: formatPrice(discount),
                    action: 'purchase'
                },
                products: productsDetails
            }
        },
        _clear: true
    }
}
